


















import Vue from "vue";

import iwInputPrice from "../buildingBlocks/InputPrice.vue";
import {resetPricingPack} from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice
    },
    data: function() {
        return {
            pathInStore: "transaction.rental.monthlyRentalPrice",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return (["HOUSE", "OFFICE", "INDUSTRY","COMMERCIAL", "APARTMENT","GARAGE","OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1
                && this.getTransactionType() === "FOR_RENT");
        },
        requestedMonthlyPrice: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (this.isDisplayed) {
            if(!this.requestedMonthlyPrice) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: 0});
            }
        } else {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(requestedMonthlyPrice: number): void {
            this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": requestedMonthlyPrice});
            resetPricingPack();
        }
    }
});
